import React, { useState } from 'react';
import './Newsletter.css';

const Newsletter = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Rediriger vers Substack
    window.open('https://corenthin.substack.com/', '_blank');
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-container">
        <h2 className="newsletter-title">RESTEZ INFORMÉ</h2>
        
        <p className="newsletter-description">
          Inscrivez-vous à la newsletter mensuelle Prosperian dédiée à l'accélération 
          de la prospection commerciale et aux meilleures pratiques du marché !
        </p>
        
        <form className="newsletter-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input 
              type="email" 
              className="newsletter-input"
              placeholder="Votre email professionnel"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="newsletter-button">S'INSCRIRE</button>
          </div>
        </form>
        
        <div className="newsletter-substack">
          <a href="https://corenthin.substack.com/" target="_blank" rel="noopener noreferrer" className="newsletter-direct-link">
            Accéder directement à notre Substack
          </a>
        </div>
      </div>
    </section>
  );
};

export default Newsletter; 